import { render, staticRenderFns } from "./InspectionFormVehicleStep.vue?vue&type=template&id=5f9bf474&scoped=true"
import script from "./InspectionFormVehicleStep.vue?vue&type=script&lang=js"
export * from "./InspectionFormVehicleStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9bf474",
  null
  
)

export default component.exports